import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white py-16 px-4" data-id="element-113">
      <div className="max-w-[600px] mx-auto text-center" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="border-2 border-gray-100 rounded-3xl p-8 md:p-10 bg-gray-50 relative" data-id="element-115">
          <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-white p-3 rounded-full border-2 border-gray-100" data-id="element-116">
            <ShieldIcon className="w-10 h-10 text-[#00A86B]" data-id="element-117" />
          </div>

          <h2 className="font-heading font-bold text-2xl mt-4 mb-6 text-[#00A86A]" data-id="element-118">
            Garantía de Satisfacción
          </h2>

          <p className="font-bold text-lg mb-4 text-[#111827]" data-id="element-119">
            Sin riesgo. Si no te sirve, te devolvemos tu plata.
          </p>

          <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-120">
            Probá las recetas durante 7 días. Si sentís que no era lo que
            esperabas, nos escribís y te hacemos el reembolso completo. Sin
            preguntas, sin vueltas.
          </p>

          <p className="font-bold text-[#111827]" data-id="element-121">
            Confiamos en lo que armamos. Y queremos que vos también confíes sin
            arriesgar nada.
          </p>
        </motion.div>
      </div>
    </section>;
}